<app-nt-btn [class]="'mat-success-button'"
    [disabled]="disabled"
    [icon]="'done'"
    [text]="completeText"
    (clicked)="executeComplete()"
    style="margin-right: 5px;"
    >
</app-nt-btn>
<app-nt-btn [color]="'warn'"
    [icon]="'close'"
    [text]="cancelText"
    (clicked)="executeCancel()"
    *ngIf="!hideCancelButton"
    style="margin-right: 5px;"
    >
</app-nt-btn>
<app-nt-btn [color]="'accent'"
    [text]="'Debug'"
    (clicked)="executeDebug()"
    *ngIf="adminUser"
    >
</app-nt-btn>